/* eslint-disable  @typescript-eslint/no-explicit-any */

import { Directive, inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { isFooterHidden, NavigationService } from '@data-terminal/data-access/navigation/navigation.service';

@Directive({
    selector: '[dataTerminalFooterVisible]',
    standalone: false,
})
export class FooterVisibleDirective {
    private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly navigationService = inject(NavigationService);

    constructor() {
        this.navigationService.navData$.pipe(isFooterHidden).subscribe((value: boolean) => {
            this.handle(value);
        });
    }

    private handle(value: boolean): void {
        if (value) {
            this.viewContainer.clear();
        } else {
            if (this.viewContainer.length === 0) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        }
    }
}
